<template>
  <div class="grid-container">
    <div class="grid-row">
      <RelacionClienteInmobiliarioGrid :id-inmueble="props.inmuebleId" :tipo-relacion="TipoRelacionClienteInmobiliarioEnum.Inquilino" @nuevaVenta="handleNuevaVenta" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import RelacionClienteInmobiliarioGrid from '@/components/relacion-cliente-inmobiliario/RelacionClienteInmobiliarioGrid.vue';
import { TipoRelacionClienteInmobiliarioEnum } from '@api/api';

interface Props {
  inmuebleId: string;
}

const emit = defineEmits(['nuevaVenta']);
const props = defineProps<Props>();

onMounted(() => {
});

const handleNuevaVenta = () => {
  emit('nuevaVenta');
}
</script>

<style lang="scss" scoped>
</style>